export default __webpack_public_path__ + "static/ways-to-earn-bg-2c96df9401cecfb5f7c78dfb432715d8.webp";